import { AuditUser } from "./auditUser"

export interface Schedule {
    id?: string,
    tenantId: string;
    title: string;
	folder?: string | null;
	scheduleType?: ScheduleType
    scheduleFreq?: ScheduleFreq;
	month?: number;
    dayOf?: number;
	date?: Date;
	dates?: Date[];
    startTime: any;
    endTime: any;
	recordsToCreate?: number
	multipleRecordInstances?: MultipleRecordInstance[]
	excludeWeekends?: boolean
    templateId: string | null
    templateTitle: string
	cadenceId?: string | null
	timeZoneId: string
    fields: { [key: string]: any }
    fieldLabels: { [key: string]: any }
	minRunDate?: Date | null
	maxRunDate?: Date | null
	created?: Date
	createdByUser?: AuditUser
	lastUpdated?: Date
	lastUpdatedByUser?: AuditUser
	bulkCreateForTeams?: string[]
	bulkCreateUserRole?: string
	bulkCreateSubRole?: string
	status?: ScheduleStatus,
	nextRun?: string | null
}

export interface FolderSchedules {
	id?: string,
	folderTitle: string
	expanded: boolean
	isFolderType: true
	schedules: Schedule[]
	allowRowClick: true
	onlyEmitOnRowClick: true,
	subFolders?: FolderSchedules[],
	parentFolderId?: string
}

export interface ScheduleQueue {
    id?: string,
	schedule: Schedule,
	scheduleType: ScheduleType,
	processAt: Date,
	processState: boolean,
	processBy: Date,
	createdAt: Date,
	createdBy: string
}

export interface MultipleRecordInstance {
    startTime?: any
	fields: { [key: string]: any }
	timezone?: string
}

export enum ScheduleType {
    Schedule,
    Cadence,
    Report
}

export enum ScheduleFreq {
    Daily = 1,
    Weekly = 2,
    Monthly = 3,
	Once = 4,
	CustomDates = 5,
	Quarterly = 6,
}

export const ScheduleFreqLabels = [
	{
		title: "Daily",
		id: ScheduleFreq.Daily
	},
	{
		title: "Weekly",
		id: ScheduleFreq.Weekly
	},
	{
		title: "Monthly",
		id: ScheduleFreq.Monthly
	}
]

export enum DayOfWeek {
    Monday = 1,
    Tuesday = 2,
    Wednesday = 3,
    Thursday = 4,
    Friday = 5,
    Saturday = 6,
    Sunday = 0
}

export enum QuarterMonth {
    FirstMonth = 1,
    SecondMonth = 2,
    ThirdMonth = 3,
}

export interface CalendarEvent {
	start: string | Date
	end: string | Date
	title: string
	hide?: boolean
}

export const DayOfWeekLabels = [
	{
		title: "Monday",
		id: DayOfWeek.Monday
	},
	{
		title: "Tuesday",
		id: DayOfWeek.Tuesday
	},
	{
		title: "Wednesday",
		id: DayOfWeek.Wednesday
	},
	{
		title: "Thursday",
		id: DayOfWeek.Thursday
	},
	{
		title: "Friday",
		id: DayOfWeek.Friday
	},
	{
		title: "Saturday",
		id: DayOfWeek.Saturday
	},
	{
		title: "Sunday",
		id: DayOfWeek.Sunday
	}
]

const DayOfMonth = Array.from({ length: 31 }, (_, index) => ({
	id: index + 1,
	title: (index + 1).toString()
}))

export { DayOfMonth }

export interface SortByOptions {
	columnKey: string,
	descending: "asc" | "desc"
}

export enum ScheduleStatus {
	Open = 1,
	Upcoming = 2,
	Closed = 3
}

const recordsToCreateValues = Array.from({ length: 15 }, (_, index) => ({
	id: index + 1,
	title: (index + 1).toString()
}))

export interface ScheduleMessage {
	scheduleId: string,
	message: string,
	autoClose: boolean,
	variant: string
}
export { recordsToCreateValues }

export const scheduleHelpers = {
	// Returns true if the scheduled month should be shown
	isOnQuarterlyDate (schedule: Schedule, currentMonth: number): boolean {
		const monthInterval = 3

		// Check how many months until the next 3 month interval
		let monthsDifference = (schedule.month! - currentMonth + monthInterval) % monthInterval

		// If theres no difference then the currentMonth is a 3 month interval
		if (monthsDifference === 0) {
			return true
		}

		return false
	}
}
